module.exports = __webpack_public_path__ + "static/media/warning.404257d7.svg";